export const SEARCH_RESULTS_LIMIT = 9;
export const SEARCH_FIELD_LIMIT = 126;
